export const zeroPad = (num, places) => String(num).padStart(places, '0');

export default zeroPad;
